export { default } from './Award';
